import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';

interface ImageWithStatusProps {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  onBroken?: () => void;
}

const ImageWithStatus: React.FC<ImageWithStatusProps> = ({
  src,
  alt,
  style,
  onBroken,
}) => {
  const [loadedSource, setLoadedSource] = useState<string | null>(null);
  const [brokenSource, setBrokenSource] = useState<string | null>(null);
  const loading = loadedSource !== src && brokenSource !== src;
  const broken = brokenSource === src;
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {!broken && (
        <img
          key={src}
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onLoad={() => {
            setLoadedSource(src);
            setBrokenSource(null);
          }}
          onError={() => {
            setBrokenSource(src);
            onBroken?.();
          }}
          style={{
            ...style,
            opacity: loading ? 0 : 1,
            transition: 'opacity 0.2s ease-in-out',
          }}
        />
      )}
      {loading && (
        <CircularProgress
          size={24}
          aria-label="Loading image"
          sx={{ position: 'absolute' }}
        />
      )}
      {broken && (
        <span
          role="img"
          aria-label="Image unavailable"
          style={{ color: '#777', fontSize: 12 }}
        >
          Image unavailable
        </span>
      )}
    </div>
  );
};

export default ImageWithStatus;
